/**
 * Created by deepak on 29-Mar-18.
 */
export const validateInput = (name, value, req, email, regex, alpha, max, min)=> {
    let errorObject = {};
    let isError = false
    console.log("IN valadating value name ",name)
    console.log("IN valadating value value ",value)
    console.log("IN valadating value req ",req)
    console.log("IN valadating value email ",email)
    console.log("IN valadating value regex ",regex)
    console.log("IN valadating value alpha ",alpha)
    console.log("IN valadating value max ",max)
    console.log("IN valadating value min ",min)
    if(req !== null){
        if(value === '' || value === null || value === undefined) {
            errorObject['required'] = name.charAt(0).toUpperCase() + name.slice(1) + " is required"
            isError = true
        }
    }
    if(email !== null){
        if(value !== '' || value !== null || value !== undefined) {
            if (/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(value) === false) {
                errorObject['email'] = name.charAt(0).toUpperCase() + name.slice(1) + " is invalid"
                isError = true
            }
        }
    }
    if(regex !== null){
        if(/^[a-zA-Z0-9_.-]/.test(value) === false) {
            errorObject['pattern'] = name.charAt(0).toUpperCase() + name.slice(1) + " does not match with below pattern"
            isError = true
        }
    }
    if(alpha !== null){
        errorObject['alpha'] = name.charAt(0).toUpperCase() + name.slice(1)+" should be aplhnumeric"
        isError = true
    }
    if(max !== null && value !== null){
        if(value && value.length > max) {
            errorObject['max'] = name.charAt(0).toUpperCase() + name.slice(1) + " should be less than " + max + " character"
            isError = true
        }
    }
    if(min !== null && value !== null){
        if(value && value.length < min) {
            errorObject['min'] = name.charAt(0).toUpperCase() + name.slice(1) + " should be more than " + min + " character"
            isError = true
        }
    }
    /*if (name !== null && name=== "url"){
        if(value !== '' || value !== null || value !== undefined) {
            if (/(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(value) === false) {
                errorObject['required'] = name.charAt(0).toUpperCase() + name.slice(1) + " is invalid";
                isError = true
            }
        }
    }*/
    if(isError === true){
        errorObject['isError'] = isError
        return errorObject
    }else{
        return null
    }

}

export const validateValue = (value,type) => {
        if(value === "" || value === '' || value === null || value === 'null' || value === 'NULL' || value === 'undefined' || value === undefined){
            return false
        }
        if(type === "N"){
            if(Number.isNaN(value) === true){
                return false
            }
        }
    return true
}

export const isRoleUser = () =>{
    let userRole = (JSON.parse(localStorage.getItem("roles") && JSON.parse(localStorage.getItem("roles")).some(v => (v === "ROLE_USER"))));
    return userRole
}

export const isAdminUser = () =>{
    let adminUser = (JSON.parse(localStorage.getItem("roles") && JSON.parse(localStorage.getItem("roles")).some(v => (v === "ROLE_ADMIN" || v === "ROLE_SYSTEM_SUPPORT" || v === "ROLE_MANAGER"))));
    return adminUser
}


// WEBPACK FOOTER //
// ./src/components/common/AppConstant.js